var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.805,
    height: 114.562,
    viewBox: "0 0 115.805 114.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "reshot-icon-arrow-up-RXWATF74GM",
    d: "M110.612,56.246,101.9,47.531,63.115,86.314V2.586H50.79V86.314L12.007,47.531,3.293,56.246l53.66,53.66Z",
    transform: "translate(0.95 0.414)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.fd2fcb5dc4fb61e82c3ce0bbd82a03ac.svg";
export { ForwardRef as ReactComponent };